import api from './';

export interface FeatureFlagStatusResponse {
    flagName: string;
    networkId: number;
    status: boolean;
}

export class FeatureFlagsService {
    static baseRoute = 'api/v2/feature_flag';

    static async getStatus(flagName: string, networkId: number): Promise<boolean> {
        const res = await api.get<FeatureFlagStatusResponse>(`${this.baseRoute}/status`, { params: { flagName, networkId } });
        return !!res.data?.status;
    }

    static async update(flagName: string, networkId: number, status: boolean): Promise<void> {
        await api.post(`${this.baseRoute}/update`, { flagName, networkId, status });
    }
}
